import { FLAGGED_AREA_SAFETIES, type FlaggedAreaListQuery } from '@chukua/common';
import { Button, Tag, type TableColumnsType } from 'antd';
import { Link } from 'react-router';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import type { FlaggedArea } from '../flagged-areas.api';
import { flaggedAreaPath } from '../flagged-areas.paths';
import { FLAGGED_AREA_SAFETY_LABELS, FLAGGED_AREA_SAFETY_TAG_COLOURS } from '../policies/flagged-area-labels';

interface ColumnsArgs {
  list: ListQueryControls<FlaggedAreaListQuery>;
  onSetActive: (area: FlaggedArea, isActive: boolean) => void;
}

export function buildFlaggedAreaColumns({ list, onSetActive }: ColumnsArgs): TableColumnsType<FlaggedArea> {
  return [
    {
      key: 'name',
      title: 'Name',
      dataIndex: 'name',
      sorter: true,
      sortOrder: list.sortOrderFor('name'),
      render: (name: string, area) => <Link to={flaggedAreaPath(area.id)}>{name}</Link>,
    },
    {
      key: 'safety',
      title: 'Kind',
      dataIndex: 'safety',
      sorter: true,
      sortOrder: list.sortOrderFor('safety'),
      filters: FLAGGED_AREA_SAFETIES.map((value) => ({ value, text: FLAGGED_AREA_SAFETY_LABELS[value] })),
      filteredValue: list.filteredValueFor('safety'),
      render: (safety: FlaggedArea['safety']) => <Tag color={FLAGGED_AREA_SAFETY_TAG_COLOURS[safety]}>{FLAGGED_AREA_SAFETY_LABELS[safety]}</Tag>,
    },
    { key: 'note', title: 'Note', dataIndex: 'note', render: (note: string | null) => note ?? '—' },
    {
      key: 'isActive',
      title: 'Status',
      dataIndex: 'isActive',
      render: (isActive: boolean) => <Tag>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      key: 'actions',
      title: '',
      align: 'right',
      render: (_: unknown, area) => (
        <Button size="small" type="link" onClick={() => onSetActive(area, !area.isActive)}>
          {area.isActive ? 'Deactivate' : 'Reactivate'}
        </Button>
      ),
    },
  ];
}
